import Icon from '../Icon';

import './PageLoadingSkeleton.scss';

const PageLoadingSkeleton = () => {
  return (
    <div className="nostra__pageLoadingSkeleton">
      <Icon variant="loading" size={64} color="--icon-default" />
    </div>
  );
};
export default PageLoadingSkeleton;
